module.exports = __webpack_public_path__ + "img/play-mov.84caedaf.svg";